import React from 'react';
import TextField from '@material-ui/core/TextField';
import NumberFormat from 'react-number-format';

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;
    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}

            onValueChange={values => {
                onChange({
                    target: {
                        value: values.formattedValue,
                    },
                });
            }}
            format="###-###-####"
            mask="_"
        />
    );
}

const PhoneNumberInput = (props) => {
    return (
        <TextField
            label="Phone Number"
            margin="normal"
            variant="outlined"
            id='name'
            fullWidth
            InputProps={{

                inputComponent: NumberFormatCustom,

            }}
            {...props}
        />
    );
}

export default PhoneNumberInput;